import {type CSSProperties} from 'react';
import styled from 'styled-components';

export const FilterContainer = styled.div`
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    display: flex;
    gap: 4rem;
    align-items: center;
    justify-content: right;

    .label {
        font-weight: 600;
        color: ${({ theme }) => theme.gray2};
    }

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
    .--select-report-container span {
        white-space: no-wrap;
        margin-top: 0;
    }

    .gi-radio_buttons__label {
        margin-bottom: 0;
    }

    .--select-report-container {
        display: flex;
        flex-direction: row;
        justify-content: start;
    }

    .usa-radio__input:checked + .usa-radio__label::before {
        background-color: ${({ theme }) => theme.primaryMain};
        -webkit-box-shadow:
            0 0 0 2px ${({ theme }) => theme.primaryMain},
            inset 0 0 0 2px ${({ theme }) => theme.defaultWhite};
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.primaryMain},
            inset 0 0 0 2px ${({ theme }) => theme.defaultWhite};
    }
`;

export const GroupByContainer = styled.div`
    .form-switch {
        align-items: center;
        display: inline-flex;
        gap: 0.35rem;
        padding-left: 0 !important;
        position: relative;
        float: none;
        margin-bottom: 0;

        .form-check-input {
            order: 2;
            float: none;
            margin: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
            position: static;
        }

        .form-check-label {
            order: 1;
            margin: 0;
            margin-right: 0.25rem;
            padding-left: 0 !important;
            white-space: nowrap;
        }

        .label {
            font-weight: 600;
            width: auto;
            margin: 0;
            white-space: nowrap;
        }

        .group-by-tag-label,
        .instruction_link {
            font-weight: 600 !important;
        }
    }
`;

export const SegmentByContainer = styled.fieldset`
    display: flex;
    gap: 1rem;
    font-weight: 600;

    .usa-list {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`;

export const FilterDropdownStyles = styled.div`
    display: flex;
    width: max-content;
    align-items: center;
    select {
        height: 3.5rem;
        width: 20rem;
    }
`;
export const StyledChartContainer = styled.div`
    min-height: 600px;
`;

export const FieldsetResetStyle: CSSProperties = {
    border: 0,
    padding: 0,
    margin: 0,
    minInlineSize: 'auto',
    alignItems: 'center',
};

export const LegendStyle: CSSProperties = {
    float: 'left',
    width: 'auto',
    margin: 0,
    padding: 0,
    fontSize: 'inherit',
    fontWeight: 600,
};